import '@sass/accordion.scss';

// Custom accordion implementation
class CWAccordion {
	constructor(accordions, options = {}) {
		this.accordions = Array.from(accordions);
		this.options = {
			itemActiveClassName: 'cw-accordion__item--open',
			itemClassName: 'cw-accordion__item',
			itemTitleClassName: 'cw-accordion__item-title',
			...options
		};
		
		this.init();
	}
	
	init() {
		this.accordions.forEach(accordion => {
			const items = accordion.querySelectorAll(`.${this.options.itemClassName}`);
			const isDisabled = accordion.classList.contains('cw-accordion--disabled');
			
			items.forEach(item => {
				const title = item.querySelector(`.${this.options.itemTitleClassName}`);
				const content = item.querySelector('.cw-accordion__item-content');
				
				if (title && content) {
					// Check if item is already open
					const isOpen = item.classList.contains(this.options.itemActiveClassName);
					
					// Set initial state
					title.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
					
					// If accordion is disabled, don't add click events
					if (!isDisabled && !title.classList.contains('cw-accordion__item-title--disabled')) {
						// Add click event - pass accordion container to toggleItem
						title.addEventListener('click', (e) => {
							e.preventDefault();
							this.toggleItem(accordion, item, title, content);
						});
					}
				}
			});
		});
	}
	
	toggleItem(accordion, item, title, content) {
		const isOpen = item.classList.contains(this.options.itemActiveClassName);
		
		if (isOpen) {
			// Close item
			item.classList.remove(this.options.itemActiveClassName);
			title.setAttribute('aria-expanded', 'false');
			content.style.display = 'none';
			content.style.opacity = '0';
		} else {
			// Check if accordion allows multiple open items
			const allOpen = accordion.getAttribute('data-all-open') === 'true';
			
			// If not allowing multiple open items, close all other open items first
			if (!allOpen) {
				const allItems = accordion.querySelectorAll(`.${this.options.itemClassName}`);
				allItems.forEach(otherItem => {
					if (otherItem !== item && otherItem.classList.contains(this.options.itemActiveClassName)) {
						const otherTitle = otherItem.querySelector(`.${this.options.itemTitleClassName}`);
						const otherContent = otherItem.querySelector('.cw-accordion__item-content');
						if (otherTitle && otherContent) {
							otherItem.classList.remove(this.options.itemActiveClassName);
							otherTitle.setAttribute('aria-expanded', 'false');
							otherContent.style.display = 'none';
							otherContent.style.opacity = '0';
						}
					}
				});
			}
			
			// Open item
			item.classList.add(this.options.itemActiveClassName);
			title.setAttribute('aria-expanded', 'true');
			content.style.display = 'block';
			content.style.opacity = '1';
		}
	}
}

// Initialize accordions
const accordions = document.querySelectorAll('.cw-accordion');
if (accordions.length) {
	new CWAccordion(accordions, {
		itemActiveClassName: 'cw-accordion__item--open',
		itemClassName: 'cw-accordion__item',
		itemTitleClassName: 'cw-accordion__item-title',
	});
}
